var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('q-translate',{attrs:{"placeholder":"エラーが発生しました。ログインし直してください。","text-key":"hall-0202"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }